import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box, TablePagination } from '@mui/material';
import { useState, useEffect } from 'react';
import UpdateDeposit from './updateDeposit';
import new_photo from 'assets/images/new_transparent.png';
import ImagesDialog from './ImagesDialog';
import { axiosInstance } from 'utils/axios';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import { useSelector } from 'react-redux';

const columns = [
    { id: 'id', label: 'ID', minWidth: 30 },
    { id: 'isNew', label: 'IsNew', minWidth: 120, type: 'indicator' },
    { id: 'clientName', label: 'Client Name', minWidth: 120 },
    { id: 'customerLoginUserName', label: 'Login User Name', minWidth: 120 },
    { id: 'amount', label: 'Amount', minWidth: 120 },
    { id: 'convertedAmount', label: 'Amount (USDT)', minWidth: 120 },
    { id: 'statusName', label: 'Status Name', minWidth: 120 },
    { id: 'thirdPartyName', label: 'Third Party Name', minWidth: 170 },
    { id: 'referrerCustomerString', label: 'Recommend By', minWidth: 170 },
    // { id: 'companyAgentClientName', label: '000 Name', minWidth: 170 },
    // { id: 'memberTypeName', label: 'Member Type', minWidth: 170 },
    { id: 'createdDate', label: 'Created Date', minWidth: 120, type: 'date' },
    { id: 'createdBy', label: 'Created By', minWidth: 120 },
    { id: 'userName', label: 'Username', minWidth: 120 },
    { id: 'transactionNumber', label: 'Transaction Number', minWidth: 170 },
    { id: 'phoneNumber', label: 'Phone Number', minWidth: 170 },
    { id: 'approvedDate', label: 'Approved Date', minWidth: 120, type: 'date' },
];

function StickyHeadTable({ deposit, fetchdepositRecord, customerLoginUserNames, status, thirdPartyIDs }) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const token = useSelector(selectCurrentToken);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const [isUserAllowEdit, setIsUserAllowEdit] = useState(false);
    const fetchIsUserAllowEdit = async () => {
        try {
            const res = await axiosInstance.get('IsAllowEdit', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setIsUserAllowEdit(res.data);
                console.log('fetchIsUserAllowEdit', res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        Promise.all([fetchIsUserAllowEdit()]).catch((error) => {
            console.error('An error occurred:', error);
        });
    }, []);

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '50px' }}>
            <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                    {column.label}
                                </TableCell>
                            ))}
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {deposit.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                    {columns.map((column) => {
                                        let value = row[column.id];
                                        if (column.type && column.type === 'indicator') {
                                            if (value === true) {
                                                value = <img src={new_photo} alt="new" style={{ width: '40%' }}></img>;
                                                // value = 'x';
                                            } else {
                                                value = '';
                                            }
                                        }
                                        if (column.type && column.type === 'date') {
                                            if (value) {
                                                const timeString12hr = new Date(
                                                    '1970-01-01T' + value.split('T')[1] + 'Z'
                                                ).toLocaleTimeString('en-US', {
                                                    timeZone: 'UTC',
                                                    hour12: true,
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    second: 'numeric'
                                                });
                                                value = `${value.split('T')[0]} ${timeString12hr}`;
                                            }
                                        }
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {typeof value === 'boolean'
                                                    ? value.toString()
                                                    : column.format && typeof value === 'number'
                                                    ? column.format(value)
                                                    : value}
                                                {/* {column.format && typeof value === 'number' ? column.format(value) : value} */}
                                            </TableCell>
                                        );
                                    })}
                                    {isUserAllowEdit &&
                                        <TableCell>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px'
                                                }}
                                            >
                                                <ImagesDialog imageUrl={row.imageUrl} />
                                            </Box>
                                        </TableCell>
                                    }
                                    {isUserAllowEdit &&
                                        <TableCell>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px'
                                                }}
                                            >
                                                <UpdateDeposit
                                                    depositList={row}
                                                    fetchdepositRecord={fetchdepositRecord}
                                                    status={status}
                                                    customerLoginUserNames={customerLoginUserNames}
                                                    thirdPartyIds={thirdPartyIDs}
                                                />
                                            </Box>
                                        </TableCell>
                                    }
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={deposit.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}

export default StickyHeadTable;
